import React, { useEffect, useState, useRef } from 'react';
import { GMap } from 'primereact/gmap';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { getJudgesMaps } from './HTTPService';

import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { loadGoogleMaps, removeGoogleMaps } from './GoogleMaps';

export const GMapDemo = () => {
    const google = window.google;

    const [googleMapsReady, setGoogleMapsReady] = useState(false);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [markerTitle, setMarkerTitle] = useState('');
    const [draggableMarker, setDraggableMarker] = useState(false);
    //const [overlays, setOverlays] = useState(null);
    const [selectedPosition, setSelectedPosition] = useState(null);

    const toast = useRef(null);
    const infoWindow = useRef(null);

    const [judgesMaps, setJudgesMaps] = useState(null);
    let overlays = [];

    useEffect(async () => {
        setJudgesMaps(await getJudgesMaps());
        
        loadGoogleMaps(() => {
            setGoogleMapsReady(true);
        });

        return () => {
            removeGoogleMaps();
        }
    }, [])

    async function addMarker() {
        for (let i = 0; i < judgesMaps.length; i++) {
            let urlColor;
            switch (judgesMaps[i].classe) {
                case 'A':
                    urlColor = "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";
                    break;
                case 'B':
                    urlColor = "http://maps.google.com/mapfiles/ms/icons/green-dot.png";
                    break;
                case 'C':
                    urlColor = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
                    break;
                default:
                    urlColor = "http://maps.google.com/mapfiles/ms/icons/purple-dot.png";
            }

            let newMarker = new google.maps.Marker({
                position: {
                    lat: judgesMaps[i].lat,
                    lng: judgesMaps[i].lng
                },
                title: judgesMaps[i].name + "\nClasse " + judgesMaps[i].classe+ "\n" + judgesMaps[i].dan+" Dan",
                icon: {
                    url: urlColor
                },
                draggable: draggableMarker
            });

            overlays.unshift(newMarker);
            setDialogVisible(false);
            setDraggableMarker(false);
            setMarkerTitle('');
        }
    }

    const onMapReady = (event) => {        
        addMarker();
    }

    const onHide = (event) => {
        setDialogVisible(false);
    }

    const options = {
        center: { lat: -12, lng: -38 },
        zoom: 4.5
    };

    const footer = <div>
        <Button label="Yes" icon="pi pi-check" onClick={addMarker} />
        <Button label="No" icon="pi pi-times" onClick={onHide} />
    </div>;

    return (
        <div>
            Árbitros JKA Brasil
            <Toast ref={toast}></Toast>

            {
                googleMapsReady && (
                    <div className="card">
                        <GMap overlays={overlays} options={options} style={{ width: '100%', minHeight: '900px' }} onMapReady={onMapReady}
                          />
                    </div>
                )
            }

            <Dialog header="New Location" visible={dialogVisible} width="300px" modal footer={footer} onHide={onHide}>
                <div className="grid p-fluid">
                    <div className="col-2" style={{ paddingTop: '.75em' }}><label htmlFor="title">Label</label></div>
                    <div className="col-10"><InputText type="text" id="title" value={markerTitle} onChange={(e) => setMarkerTitle(e.target.value)} /></div>

                    <div className="col-2" style={{ paddingTop: '.75em' }}>Lat</div>
                    <div className="col-10"><InputText readOnly value={selectedPosition ? selectedPosition.lat() : ''} /></div>

                    <div className="col-2" style={{ paddingTop: '.75em' }}>Lng</div>
                    <div className="col-10"><InputText readOnly value={selectedPosition ? selectedPosition.lng() : ''} /></div>

                    <div className="col-2" style={{ paddingTop: '.75em' }}><label htmlFor="drg">Drag</label></div>
                    <div className="col-10"><Checkbox checked={draggableMarker} onChange={(event) => setDraggableMarker(event.checked)} /></div>
                </div>
            </Dialog>
        </div>
    );
}

